export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      top10: "Top 10 dApps",
      top20: "Preferred dApps",
      apply: "Apply",
      dashboard: "Dashboard",
      admin: "Admin"
    },
    // Hero Section
    hero: {
      headline: "Build the Next Generation of dApps on UNI2Chain",
      subheadline: "Join our Builders Program and develop one of our strategic priority applications. Access grants, revenue share models, ecosystem support and long-term collaboration.",
      cta_top10: "View Top 10 Strategic dApps",
      cta_proposal: "Submit a Proposal",
      cta_partner: "Apply as Development Partner"
    },
    // Why Build Section
    whyBuild: {
      headline: "Why Build on UNI2Chain?",
      intro: "We are building long-term infrastructure, not short-term speculation.",
      features: {
        lowCost: "Low transaction costs",
        scalability: "High scalability infrastructure",
        accountAbstraction: "Account abstraction ready",
        governance: "Governance-ready ecosystem",
        realWorld: "Real-world vertical integration",
        community: "Active community and expansion roadmap"
      }
    },
    // Top 10 Section
    top10: {
      headline: "Top 10 Strategic dApps – Critical Priority",
      subtext: "These applications are essential for ecosystem growth and will receive structured support and evaluation priority.",
      applyBtn: "Apply to Build",
      impact: "Expected Impact",
      priority: "Priority",
      incentive: "Incentive Model",
      status: "Status"
    },
    // Top 20 Section
    top20: {
      headline: "Preferred Strategic Developments",
      subtext: "High-value ecosystem enhancements open for builder proposals.",
      applyBtn: "Apply"
    },
    // Open Proposals Section
    openProposals: {
      headline: "Propose Your Own dApp",
      description: "Have an idea that fits UNI2Chain's infrastructure vision? Submit your independent proposal for review by the UNI2 technical committee.",
      cta: "Submit Proposal"
    },
    // Application Form
    form: {
      headline: "Builder Application",
      teamInfo: "Team Information",
      teamName: "Team Name",
      country: "Country",
      website: "Website",
      github: "GitHub",
      linkedin: "LinkedIn",
      previousProjects: "Previous Web3 Projects",
      selectedDapp: "Selected dApp",
      selectPlaceholder: "Select a dApp or Custom Proposal",
      customProposal: "Custom Proposal",
      techArchitecture: "Technical Architecture",
      smartContract: "Smart Contract Design",
      scalability: "Scalability Strategy",
      securityPlan: "Security Plan",
      techStack: "Tech Stack",
      timeline: "Timeline",
      mvp: "MVP Date",
      beta: "Beta Date",
      mainnet: "Mainnet Date",
      incentivePref: "Incentive Preference",
      grant: "Grant",
      revenueShare: "Revenue Share",
      hybrid: "Hybrid",
      strategic: "Strategic Partnership",
      whyUni2: "Why UNI2Chain?",
      fileUpload: "Upload Whitepaper or Deck",
      submit: "Submit Builder Application",
      submitting: "Submitting...",
      success: "Application submitted successfully!",
      error: "Error submitting application"
    },
    // Dashboard
    dashboard: {
      headline: "Ecosystem Development Tracker",
      inReview: "In Review",
      approved: "Approved",
      inDevelopment: "In Development",
      live: "Live",
      total: "Total Projects"
    },
    // Admin
    admin: {
      login: "Admin Login",
      password: "Password",
      loginBtn: "Login",
      logout: "Logout",
      proposals: "Proposals",
      updateStatus: "Update Status",
      viewDetails: "View Details"
    },
    // Categories
    categories: {
      gaming: "Gaming & Engagement",
      social: "Social Infrastructure",
      defi: "DeFi Infrastructure",
      lending: "Lending & Borrowing",
      payments: "Payments",
      nft: "NFT Utility",
      gamification: "Gamification",
      governance: "Governance",
      security: "Security",
      rwa: "Real World Assets",
      ai: "AI & ML",
      staking: "Staking",
      payroll: "Payroll",
      crosschain: "Cross-chain",
      data: "Data",
      insurance: "Insurance",
      creator: "Creator Economy",
      loyalty: "Loyalty",
      oracle: "Oracle",
      analytics: "Analytics",
      nocode: "No-Code",
      launchpad: "Launchpad",
      bridge: "Bridge",
      carbon: "Carbon Credits",
      supply: "Supply Chain",
      invoice: "Invoice",
      dao: "DAO"
    },
    // Status
    statuses: {
      open: "Open for proposals",
      review: "In Review",
      approved: "Approved",
      development: "In Development",
      live: "Live"
    },
    // Incentives
    incentives: {
      grant: "Grant",
      revenueShare: "Revenue Share",
      grantRevenue: "Grant + Revenue Share",
      strategic: "Strategic Partnership"
    },
    // Hackathons
    hackathons: {
      title: "Hackathons",
      subtitle: "Join our hackathons and compete for prizes while building on UNI2Chain",
      upcoming: "Upcoming",
      active: "Active",
      completed: "Completed",
      registerNow: "Register Now",
      viewDetails: "View Details",
      prizes: "Prizes",
      tracks: "Tracks",
      participants: "Participants",
      deadline: "Registration Deadline",
      startDate: "Start Date",
      endDate: "End Date",
      requirements: "Requirements",
      registration: "Hackathon Registration",
      teamName: "Team Name",
      teamMembers: "Team Members",
      memberName: "Name",
      memberRole: "Role",
      memberGithub: "GitHub",
      addMember: "Add Team Member",
      selectTrack: "Select Track",
      projectIdea: "Project Idea",
      contactEmail: "Contact Email",
      registerTeam: "Register Team",
      registrationSuccess: "Successfully registered for hackathon!",
      registrationError: "Error registering for hackathon",
      statusUpcoming: "Upcoming",
      statusOpen: "Registration Open",
      statusActive: "Active",
      statusJudging: "Judging",
      statusCompleted: "Completed"
    },
    // Builder Score
    score: {
      title: "Builder Score",
      breakdown: "Score Breakdown",
      teamInfo: "Team Info",
      techArchitecture: "Technical Architecture",
      timeline: "Timeline",
      whyUni2: "Why UNI2",
      projectSelection: "Project Selection",
      high: "High Priority",
      medium: "Medium Priority",
      low: "Low Priority"
    },
    // NDA
    nda: {
      generate: "Generate NDA",
      download: "Download NDA",
      generated: "NDA Generated"
    }
  },
  es: {
    nav: {
      home: "Inicio",
      top10: "Top 10 dApps",
      top20: "dApps Preferidas",
      apply: "Aplicar",
      dashboard: "Panel",
      admin: "Admin"
    },
    hero: {
      headline: "Construye la Próxima Generación de dApps en UNI2Chain",
      subheadline: "Únete a nuestro Programa de Builders y desarrolla una de nuestras aplicaciones prioritarias estratégicas. Accede a subvenciones, modelos de reparto de ingresos, soporte del ecosistema y colaboración a largo plazo.",
      cta_top10: "Ver Top 10 dApps Estratégicas",
      cta_proposal: "Enviar una Propuesta",
      cta_partner: "Aplicar como Partner de Desarrollo"
    },
    whyBuild: {
      headline: "¿Por qué Construir en UNI2Chain?",
      intro: "Estamos construyendo infraestructura a largo plazo, no especulación a corto plazo.",
      features: {
        lowCost: "Bajos costos de transacción",
        scalability: "Infraestructura de alta escalabilidad",
        accountAbstraction: "Abstracción de cuentas lista",
        governance: "Ecosistema preparado para gobernanza",
        realWorld: "Integración vertical del mundo real",
        community: "Comunidad activa y hoja de ruta de expansión"
      }
    },
    top10: {
      headline: "Top 10 dApps Estratégicas – Prioridad Crítica",
      subtext: "Estas aplicaciones son esenciales para el crecimiento del ecosistema y recibirán soporte estructurado y prioridad de evaluación.",
      applyBtn: "Aplicar para Construir",
      impact: "Impacto Esperado",
      priority: "Prioridad",
      incentive: "Modelo de Incentivos",
      status: "Estado"
    },
    top20: {
      headline: "Desarrollos Estratégicos Preferidos",
      subtext: "Mejoras de alto valor del ecosistema abiertas para propuestas de builders.",
      applyBtn: "Aplicar"
    },
    openProposals: {
      headline: "Propón Tu Propia dApp",
      description: "¿Tienes una idea que encaja con la visión de infraestructura de UNI2Chain? Envía tu propuesta independiente para revisión por el comité técnico de UNI2.",
      cta: "Enviar Propuesta"
    },
    form: {
      headline: "Aplicación de Builder",
      teamInfo: "Información del Equipo",
      teamName: "Nombre del Equipo",
      country: "País",
      website: "Sitio Web",
      github: "GitHub",
      linkedin: "LinkedIn",
      previousProjects: "Proyectos Web3 Anteriores",
      selectedDapp: "dApp Seleccionada",
      selectPlaceholder: "Selecciona una dApp o Propuesta Personalizada",
      customProposal: "Propuesta Personalizada",
      techArchitecture: "Arquitectura Técnica",
      smartContract: "Diseño de Contrato Inteligente",
      scalability: "Estrategia de Escalabilidad",
      securityPlan: "Plan de Seguridad",
      techStack: "Stack Tecnológico",
      timeline: "Cronograma",
      mvp: "Fecha MVP",
      beta: "Fecha Beta",
      mainnet: "Fecha Mainnet",
      incentivePref: "Preferencia de Incentivos",
      grant: "Subvención",
      revenueShare: "Reparto de Ingresos",
      hybrid: "Híbrido",
      strategic: "Partnership Estratégica",
      whyUni2: "¿Por qué UNI2Chain?",
      fileUpload: "Subir Whitepaper o Presentación",
      submit: "Enviar Aplicación de Builder",
      submitting: "Enviando...",
      success: "¡Aplicación enviada con éxito!",
      error: "Error al enviar la aplicación"
    },
    dashboard: {
      headline: "Rastreador de Desarrollo del Ecosistema",
      inReview: "En Revisión",
      approved: "Aprobados",
      inDevelopment: "En Desarrollo",
      live: "En Vivo",
      total: "Total de Proyectos"
    },
    admin: {
      login: "Acceso Admin",
      password: "Contraseña",
      loginBtn: "Entrar",
      logout: "Salir",
      proposals: "Propuestas",
      updateStatus: "Actualizar Estado",
      viewDetails: "Ver Detalles"
    },
    categories: {
      gaming: "Gaming y Engagement",
      social: "Infraestructura Social",
      defi: "Infraestructura DeFi",
      lending: "Préstamos",
      payments: "Pagos",
      nft: "Utilidad NFT",
      gamification: "Gamificación",
      governance: "Gobernanza",
      security: "Seguridad",
      rwa: "Activos del Mundo Real",
      ai: "IA y ML",
      staking: "Staking",
      payroll: "Nómina",
      crosschain: "Cross-chain",
      data: "Datos",
      insurance: "Seguros",
      creator: "Economía de Creadores",
      loyalty: "Lealtad",
      oracle: "Oracle",
      analytics: "Analíticas",
      nocode: "No-Code",
      launchpad: "Launchpad",
      bridge: "Bridge",
      carbon: "Créditos de Carbono",
      supply: "Cadena de Suministro",
      invoice: "Facturas",
      dao: "DAO"
    },
    statuses: {
      open: "Abierto para propuestas",
      review: "En Revisión",
      approved: "Aprobado",
      development: "En Desarrollo",
      live: "En Vivo"
    },
    incentives: {
      grant: "Subvención",
      revenueShare: "Reparto de Ingresos",
      grantRevenue: "Subvención + Reparto",
      strategic: "Partnership Estratégica"
    },
    hackathons: {
      title: "Hackathons",
      subtitle: "Participa en nuestros hackathons y compite por premios mientras construyes en UNI2Chain",
      upcoming: "Próximos",
      active: "Activos",
      completed: "Completados",
      registerNow: "Registrarse Ahora",
      viewDetails: "Ver Detalles",
      prizes: "Premios",
      tracks: "Categorías",
      participants: "Participantes",
      deadline: "Fecha Límite de Registro",
      startDate: "Fecha de Inicio",
      endDate: "Fecha de Fin",
      requirements: "Requisitos",
      registration: "Registro de Hackathon",
      teamName: "Nombre del Equipo",
      teamMembers: "Miembros del Equipo",
      memberName: "Nombre",
      memberRole: "Rol",
      memberGithub: "GitHub",
      addMember: "Agregar Miembro",
      selectTrack: "Seleccionar Categoría",
      projectIdea: "Idea del Proyecto",
      contactEmail: "Email de Contacto",
      registerTeam: "Registrar Equipo",
      registrationSuccess: "¡Registrado exitosamente en el hackathon!",
      registrationError: "Error al registrarse en el hackathon",
      statusUpcoming: "Próximo",
      statusOpen: "Registro Abierto",
      statusActive: "Activo",
      statusJudging: "En Evaluación",
      statusCompleted: "Completado"
    },
    score: {
      title: "Puntuación de Builder",
      breakdown: "Desglose de Puntuación",
      teamInfo: "Info del Equipo",
      techArchitecture: "Arquitectura Técnica",
      timeline: "Cronograma",
      whyUni2: "Por qué UNI2",
      projectSelection: "Selección de Proyecto",
      high: "Alta Prioridad",
      medium: "Media Prioridad",
      low: "Baja Prioridad"
    },
    nda: {
      generate: "Generar NDA",
      download: "Descargar NDA",
      generated: "NDA Generado"
    }
  },
  ru: {
    nav: {
      home: "Главная",
      top10: "Топ 10 dApps",
      top20: "Предпочтительные dApps",
      apply: "Подать заявку",
      dashboard: "Панель",
      admin: "Админ"
    },
    hero: {
      headline: "Создайте следующее поколение dApps на UNI2Chain",
      subheadline: "Присоединяйтесь к нашей программе Builders и разрабатывайте одно из наших стратегических приоритетных приложений. Получите доступ к грантам, моделям распределения доходов, поддержке экосистемы и долгосрочному сотрудничеству.",
      cta_top10: "Посмотреть Топ 10 Стратегических dApps",
      cta_proposal: "Подать Предложение",
      cta_partner: "Подать заявку как Партнер по Разработке"
    },
    whyBuild: {
      headline: "Почему стоит строить на UNI2Chain?",
      intro: "Мы строим долгосрочную инфраструктуру, а не краткосрочные спекуляции.",
      features: {
        lowCost: "Низкие транзакционные издержки",
        scalability: "Высокомасштабируемая инфраструктура",
        accountAbstraction: "Готовность к абстракции аккаунтов",
        governance: "Экосистема готова к управлению",
        realWorld: "Интеграция с реальным миром",
        community: "Активное сообщество и дорожная карта расширения"
      }
    },
    top10: {
      headline: "Топ 10 Стратегических dApps – Критический Приоритет",
      subtext: "Эти приложения необходимы для роста экосистемы и получат структурированную поддержку и приоритет оценки.",
      applyBtn: "Подать заявку на разработку",
      impact: "Ожидаемое воздействие",
      priority: "Приоритет",
      incentive: "Модель стимулирования",
      status: "Статус"
    },
    top20: {
      headline: "Предпочтительные Стратегические Разработки",
      subtext: "Высокоценные улучшения экосистемы открыты для предложений разработчиков.",
      applyBtn: "Подать заявку"
    },
    openProposals: {
      headline: "Предложите Свою dApp",
      description: "Есть идея, соответствующая инфраструктурному видению UNI2Chain? Отправьте свое независимое предложение на рассмотрение техническому комитету UNI2.",
      cta: "Отправить Предложение"
    },
    form: {
      headline: "Заявка Разработчика",
      teamInfo: "Информация о Команде",
      teamName: "Название Команды",
      country: "Страна",
      website: "Веб-сайт",
      github: "GitHub",
      linkedin: "LinkedIn",
      previousProjects: "Предыдущие Web3 Проекты",
      selectedDapp: "Выбранная dApp",
      selectPlaceholder: "Выберите dApp или Пользовательское Предложение",
      customProposal: "Пользовательское Предложение",
      techArchitecture: "Техническая Архитектура",
      smartContract: "Дизайн Смарт-Контракта",
      scalability: "Стратегия Масштабирования",
      securityPlan: "План Безопасности",
      techStack: "Технологический Стек",
      timeline: "Сроки",
      mvp: "Дата MVP",
      beta: "Дата Beta",
      mainnet: "Дата Mainnet",
      incentivePref: "Предпочтение Стимулирования",
      grant: "Грант",
      revenueShare: "Распределение Доходов",
      hybrid: "Гибрид",
      strategic: "Стратегическое Партнерство",
      whyUni2: "Почему UNI2Chain?",
      fileUpload: "Загрузить Whitepaper или Презентацию",
      submit: "Отправить Заявку Разработчика",
      submitting: "Отправка...",
      success: "Заявка успешно отправлена!",
      error: "Ошибка при отправке заявки"
    },
    dashboard: {
      headline: "Трекер Развития Экосистемы",
      inReview: "На Рассмотрении",
      approved: "Одобрено",
      inDevelopment: "В Разработке",
      live: "Запущено",
      total: "Всего Проектов"
    },
    admin: {
      login: "Вход Админа",
      password: "Пароль",
      loginBtn: "Войти",
      logout: "Выйти",
      proposals: "Предложения",
      updateStatus: "Обновить Статус",
      viewDetails: "Подробности"
    },
    categories: {
      gaming: "Игры и Вовлечение",
      social: "Социальная Инфраструктура",
      defi: "DeFi Инфраструктура",
      lending: "Кредитование",
      payments: "Платежи",
      nft: "NFT Утилита",
      gamification: "Геймификация",
      governance: "Управление",
      security: "Безопасность",
      rwa: "Реальные Активы",
      ai: "ИИ и ML",
      staking: "Стейкинг",
      payroll: "Зарплата",
      crosschain: "Кросс-чейн",
      data: "Данные",
      insurance: "Страхование",
      creator: "Экономика Создателей",
      loyalty: "Лояльность",
      oracle: "Оракул",
      analytics: "Аналитика",
      nocode: "Без Кода",
      launchpad: "Лаунчпад",
      bridge: "Мост",
      carbon: "Углеродные Кредиты",
      supply: "Цепочка Поставок",
      invoice: "Счета",
      dao: "DAO"
    },
    statuses: {
      open: "Открыто для предложений",
      review: "На рассмотрении",
      approved: "Одобрено",
      development: "В разработке",
      live: "Запущено"
    },
    incentives: {
      grant: "Грант",
      revenueShare: "Распределение доходов",
      grantRevenue: "Грант + Распределение",
      strategic: "Стратегическое партнерство"
    }
  },
  ur: {
    nav: {
      home: "ہوم",
      top10: "ٹاپ 10 dApps",
      top20: "ترجیحی dApps",
      apply: "درخواست دیں",
      dashboard: "ڈیش بورڈ",
      admin: "ایڈمن"
    },
    hero: {
      headline: "UNI2Chain پر dApps کی اگلی نسل بنائیں",
      subheadline: "ہمارے بلڈرز پروگرام میں شامل ہوں اور ہماری اسٹریٹجک ترجیحی ایپلیکیشنز میں سے ایک تیار کریں۔ گرانٹس، ریونیو شیئر ماڈلز، ایکو سسٹم سپورٹ اور طویل مدتی تعاون تک رسائی حاصل کریں۔",
      cta_top10: "ٹاپ 10 اسٹریٹجک dApps دیکھیں",
      cta_proposal: "تجویز جمع کرائیں",
      cta_partner: "ڈیولپمنٹ پارٹنر کے طور پر درخواست دیں"
    },
    whyBuild: {
      headline: "UNI2Chain پر کیوں بنائیں؟",
      intro: "ہم طویل مدتی انفراسٹرکچر بنا رہے ہیں، قلیل مدتی قیاس آرائی نہیں۔",
      features: {
        lowCost: "کم لین دین کی لاگت",
        scalability: "اعلی اسکیل ایبلٹی انفراسٹرکچر",
        accountAbstraction: "اکاؤنٹ ایبسٹریکشن تیار",
        governance: "گورننس ریڈی ایکو سسٹم",
        realWorld: "حقیقی دنیا کا عمودی انضمام",
        community: "فعال کمیونٹی اور توسیع کا روڈ میپ"
      }
    },
    top10: {
      headline: "ٹاپ 10 اسٹریٹجک dApps – اہم ترجیح",
      subtext: "یہ ایپلیکیشنز ایکو سسٹم کی ترقی کے لیے ضروری ہیں اور انہیں ساختی مدد اور تشخیص کی ترجیح ملے گی۔",
      applyBtn: "بنانے کے لیے درخواست دیں",
      impact: "متوقع اثر",
      priority: "ترجیح",
      incentive: "ترغیبی ماڈل",
      status: "حیثیت"
    },
    top20: {
      headline: "ترجیحی اسٹریٹجک ترقیات",
      subtext: "بلڈر تجاویز کے لیے کھلی اعلی قدر ایکو سسٹم بہتری۔",
      applyBtn: "درخواست دیں"
    },
    openProposals: {
      headline: "اپنی dApp تجویز کریں",
      description: "کیا آپ کے پاس کوئی خیال ہے جو UNI2Chain کے انفراسٹرکچر وژن سے میل کھاتا ہے؟ UNI2 تکنیکی کمیٹی کے جائزے کے لیے اپنی آزاد تجویز جمع کرائیں۔",
      cta: "تجویز جمع کرائیں"
    },
    form: {
      headline: "بلڈر درخواست",
      teamInfo: "ٹیم کی معلومات",
      teamName: "ٹیم کا نام",
      country: "ملک",
      website: "ویب سائٹ",
      github: "GitHub",
      linkedin: "LinkedIn",
      previousProjects: "پچھلے Web3 پروجیکٹس",
      selectedDapp: "منتخب dApp",
      selectPlaceholder: "dApp یا اپنی مرضی کی تجویز منتخب کریں",
      customProposal: "اپنی مرضی کی تجویز",
      techArchitecture: "تکنیکی فن تعمیر",
      smartContract: "سمارٹ کنٹریکٹ ڈیزائن",
      scalability: "اسکیل ایبلٹی حکمت عملی",
      securityPlan: "سیکیورٹی پلان",
      techStack: "ٹیک اسٹیک",
      timeline: "ٹائم لائن",
      mvp: "MVP تاریخ",
      beta: "بیٹا تاریخ",
      mainnet: "مین نیٹ تاریخ",
      incentivePref: "ترغیبی ترجیح",
      grant: "گرانٹ",
      revenueShare: "ریونیو شیئر",
      hybrid: "ہائبرڈ",
      strategic: "اسٹریٹجک پارٹنرشپ",
      whyUni2: "UNI2Chain کیوں؟",
      fileUpload: "وائٹ پیپر یا ڈیک اپ لوڈ کریں",
      submit: "بلڈر درخواست جمع کرائیں",
      submitting: "جمع ہو رہا ہے...",
      success: "درخواست کامیابی سے جمع ہو گئی!",
      error: "درخواست جمع کرانے میں خرابی"
    },
    dashboard: {
      headline: "ایکو سسٹم ڈیولپمنٹ ٹریکر",
      inReview: "جائزے میں",
      approved: "منظور شدہ",
      inDevelopment: "ترقی میں",
      live: "لائیو",
      total: "کل پروجیکٹس"
    },
    admin: {
      login: "ایڈمن لاگ ان",
      password: "پاس ورڈ",
      loginBtn: "لاگ ان",
      logout: "لاگ آؤٹ",
      proposals: "تجاویز",
      updateStatus: "حیثیت اپ ڈیٹ کریں",
      viewDetails: "تفصیلات دیکھیں"
    },
    categories: {
      gaming: "گیمنگ اور انگیجمنٹ",
      social: "سماجی انفراسٹرکچر",
      defi: "DeFi انفراسٹرکچر",
      lending: "قرض دینا",
      payments: "ادائیگیاں",
      nft: "NFT یوٹیلٹی",
      gamification: "گیمیفیکیشن",
      governance: "گورننس",
      security: "سیکیورٹی",
      rwa: "حقیقی دنیا کے اثاثے",
      ai: "AI اور ML",
      staking: "اسٹیکنگ",
      payroll: "پے رول",
      crosschain: "کراس چین",
      data: "ڈیٹا",
      insurance: "انشورنس",
      creator: "کریٹر اکانومی",
      loyalty: "وفاداری",
      oracle: "اوریکل",
      analytics: "تجزیات",
      nocode: "نو کوڈ",
      launchpad: "لانچ پیڈ",
      bridge: "برج",
      carbon: "کاربن کریڈٹس",
      supply: "سپلائی چین",
      invoice: "انوائس",
      dao: "DAO"
    },
    statuses: {
      open: "تجاویز کے لیے کھلا",
      review: "جائزے میں",
      approved: "منظور شدہ",
      development: "ترقی میں",
      live: "لائیو"
    },
    incentives: {
      grant: "گرانٹ",
      revenueShare: "ریونیو شیئر",
      grantRevenue: "گرانٹ + ریونیو شیئر",
      strategic: "اسٹریٹجک پارٹنرشپ"
    }
  },
  hi: {
    nav: {
      home: "होम",
      top10: "टॉप 10 dApps",
      top20: "पसंदीदा dApps",
      apply: "आवेदन करें",
      dashboard: "डैशबोर्ड",
      admin: "एडमिन"
    },
    hero: {
      headline: "UNI2Chain पर dApps की अगली पीढ़ी बनाएं",
      subheadline: "हमारे बिल्डर्स प्रोग्राम में शामिल हों और हमारी रणनीतिक प्राथमिकता वाले एप्लिकेशन में से एक विकसित करें। अनुदान, राजस्व साझा मॉडल, इकोसिस्टम समर्थन और दीर्घकालिक सहयोग तक पहुंच प्राप्त करें।",
      cta_top10: "टॉप 10 रणनीतिक dApps देखें",
      cta_proposal: "प्रस्ताव जमा करें",
      cta_partner: "विकास भागीदार के रूप में आवेदन करें"
    },
    whyBuild: {
      headline: "UNI2Chain पर क्यों बनाएं?",
      intro: "हम दीर्घकालिक इंफ्रास्ट्रक्चर बना रहे हैं, अल्पकालिक अटकलें नहीं।",
      features: {
        lowCost: "कम लेनदेन लागत",
        scalability: "उच्च स्केलेबिलिटी इंफ्रास्ट्रक्चर",
        accountAbstraction: "अकाउंट एब्स्ट्रैक्शन तैयार",
        governance: "गवर्नेंस-रेडी इकोसिस्टम",
        realWorld: "वास्तविक दुनिया का वर्टिकल एकीकरण",
        community: "सक्रिय समुदाय और विस्तार रोडमैप"
      }
    },
    top10: {
      headline: "टॉप 10 रणनीतिक dApps – महत्वपूर्ण प्राथमिकता",
      subtext: "ये एप्लिकेशन इकोसिस्टम वृद्धि के लिए आवश्यक हैं और संरचित समर्थन और मूल्यांकन प्राथमिकता प्राप्त करेंगे।",
      applyBtn: "बनाने के लिए आवेदन करें",
      impact: "अपेक्षित प्रभाव",
      priority: "प्राथमिकता",
      incentive: "प्रोत्साहन मॉडल",
      status: "स्थिति"
    },
    top20: {
      headline: "पसंदीदा रणनीतिक विकास",
      subtext: "बिल्डर प्रस्तावों के लिए खुले उच्च-मूल्य इकोसिस्टम संवर्द्धन।",
      applyBtn: "आवेदन करें"
    },
    openProposals: {
      headline: "अपनी dApp प्रस्तावित करें",
      description: "क्या आपके पास कोई विचार है जो UNI2Chain के इंफ्रास्ट्रक्चर विजन से मेल खाता है? UNI2 तकनीकी समिति द्वारा समीक्षा के लिए अपना स्वतंत्र प्रस्ताव जमा करें।",
      cta: "प्रस्ताव जमा करें"
    },
    form: {
      headline: "बिल्डर आवेदन",
      teamInfo: "टीम जानकारी",
      teamName: "टीम का नाम",
      country: "देश",
      website: "वेबसाइट",
      github: "GitHub",
      linkedin: "LinkedIn",
      previousProjects: "पिछले Web3 प्रोजेक्ट्स",
      selectedDapp: "चयनित dApp",
      selectPlaceholder: "dApp या कस्टम प्रस्ताव चुनें",
      customProposal: "कस्टम प्रस्ताव",
      techArchitecture: "तकनीकी वास्तुकला",
      smartContract: "स्मार्ट कॉन्ट्रैक्ट डिजाइन",
      scalability: "स्केलेबिलिटी रणनीति",
      securityPlan: "सुरक्षा योजना",
      techStack: "टेक स्टैक",
      timeline: "समयरेखा",
      mvp: "MVP तारीख",
      beta: "बीटा तारीख",
      mainnet: "मेननेट तारीख",
      incentivePref: "प्रोत्साहन वरीयता",
      grant: "अनुदान",
      revenueShare: "राजस्व साझा",
      hybrid: "हाइब्रिड",
      strategic: "रणनीतिक साझेदारी",
      whyUni2: "UNI2Chain क्यों?",
      fileUpload: "व्हाइटपेपर या डेक अपलोड करें",
      submit: "बिल्डर आवेदन जमा करें",
      submitting: "जमा हो रहा है...",
      success: "आवेदन सफलतापूर्वक जमा!",
      error: "आवेदन जमा करने में त्रुटि"
    },
    dashboard: {
      headline: "इकोसिस्टम विकास ट्रैकर",
      inReview: "समीक्षा में",
      approved: "स्वीकृत",
      inDevelopment: "विकास में",
      live: "लाइव",
      total: "कुल प्रोजेक्ट्स"
    },
    admin: {
      login: "एडमिन लॉगिन",
      password: "पासवर्ड",
      loginBtn: "लॉगिन",
      logout: "लॉगआउट",
      proposals: "प्रस्ताव",
      updateStatus: "स्थिति अपडेट करें",
      viewDetails: "विवरण देखें"
    },
    categories: {
      gaming: "गेमिंग और एंगेजमेंट",
      social: "सामाजिक इंफ्रास्ट्रक्चर",
      defi: "DeFi इंफ्रास्ट्रक्चर",
      lending: "उधार",
      payments: "भुगतान",
      nft: "NFT उपयोगिता",
      gamification: "गेमिफिकेशन",
      governance: "गवर्नेंस",
      security: "सुरक्षा",
      rwa: "वास्तविक विश्व संपत्ति",
      ai: "AI और ML",
      staking: "स्टेकिंग",
      payroll: "पेरोल",
      crosschain: "क्रॉस-चेन",
      data: "डेटा",
      insurance: "बीमा",
      creator: "क्रिएटर इकोनॉमी",
      loyalty: "लॉयल्टी",
      oracle: "ओरेकल",
      analytics: "एनालिटिक्स",
      nocode: "नो-कोड",
      launchpad: "लॉन्चपैड",
      bridge: "ब्रिज",
      carbon: "कार्बन क्रेडिट",
      supply: "सप्लाई चेन",
      invoice: "इनवॉइस",
      dao: "DAO"
    },
    statuses: {
      open: "प्रस्तावों के लिए खुला",
      review: "समीक्षा में",
      approved: "स्वीकृत",
      development: "विकास में",
      live: "लाइव"
    },
    incentives: {
      grant: "अनुदान",
      revenueShare: "राजस्व साझा",
      grantRevenue: "अनुदान + राजस्व साझा",
      strategic: "रणनीतिक साझेदारी"
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let result = translations[lang];
  for (const k of keys) {
    if (result && result[k]) {
      result = result[k];
    } else {
      // Fallback to English
      result = translations['en'];
      for (const kFallback of keys) {
        if (result && result[kFallback]) {
          result = result[kFallback];
        } else {
          return key;
        }
      }
      return result;
    }
  }
  return result;
};
